import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// The campo card. Loaded with useQuery and not a loader: the 404 has to stay an in-page
// message rather than RouteError's full screen.

export const pitchDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pitches/$id',
  params: numericIdParam,
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/pitch-detail.tsx')),
})
